/* global App */

<template>
    <span>
        <transition name="width">
            <div id="search-sidebar"
             :class="[mobileMapVisible ? 'height-transition' : '', 'col-xs-12 col-sm-6 col-md-4']"
             v-show="openSidebar">
                <div id="search-sidebar-scroll">
                    <div v-if="noResults" id='no-results'>
                        <p>No results found within 200km of your location.</p>
                        <p>Check back later or help out by submitting a listing</p>
                    </div>
                    <ul id='beaches' class='tags'>
                      <li v-for="(beach, idx) in beaches" :id="['beach-' + idx]" :class="{active: beach.active}">
                        <a href="#" v-on:click="toggleActiveBeach(beach)">
                            <div>
                            <span class="beach-marker">{{ String.fromCharCode(65 + idx) }}</span>
                            <span class='detail'
                             :class="[beach.active ? 'icon-search-minus' : 'icon-search-plus']"
                            ></span>
                            </div>
                            <p>{{ beach.Name }}, {{ beach.Locality }}</p>
                            <p class='tag' v-if="beach.distance">{{ beach.distance }} km</p>
                        </a>
                      </li>
                    </ul>
                </div>
            </div>
        </transition>
        <div id='search-wrapper' class="col-xs-12 col-sm-6 col-md-4">
            <button class="locate-button locate-me button button-only-icon praias-button"
                v-on:click='locateMe' v-show="!mobileMapVisible">
                <span id='locate-me' class="icon-crosshairs" :class="{active: locateActive}"></span>
            </button>
            <div class="input search-container" v-show="!mobileMapVisible">
                <input id="search" placeholder="Search" type="text" v-model="searchInput">
            </div>

            <button class="switch-button button button-only-icon praias-button"
             v-show="openSidebar"
             v-on:click="toggleMap()">
             <span id="details-exchange" class="icon-exchange"></span>
            </button>
        </div>
    </span>
</template>

<script>
export default {
    data: function () {
        return {
            searchInput: '',
            markers: [],
            beaches: [],
            userPos: null,
            openSidebar: false,
            mobileMapVisible: false,
            noResults: false,
            locateActive: false,
            showDetails: false,
        }
    },
    props: ['place'],
    watch: {
        place: function (val, oldVal) {
          // user selected a swimspot in location dropdown
          this.searchMe()
        },
    },
    mounted: function () {
        eventBus.$on('showDetailsEvent', (kwargs) => {
          this.showDetails = kwargs['showDetails']
        })
        eventBus.$on('slugSearchEvent', (beach) => {
          this.clearAll()
          this.updateSingleLocation(beach, 0)
          this.toggleActiveBeach(this.beaches[0])
          this.openSidebar = true
        })
        window.addEventListener('resize', this.handleResize)
    },
    methods: {
        handleResize: function(event) {
            if (event.target.innerWidth > 768 && this.mobileMapVisible === true) {
                this.mobileMapVisible = false
            }
            var center = App.map.getCenter()
            google.maps.event.trigger(App.map, "resize")
            App.map.setCenter(center)
        },
        placeFromCoords: function() {
            // placeholder, needs to get place from coords, return place
        },
        locateMe: function(event) {
            var vm = this
            App.showLoading()
            vm.locateActive = true
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {

                    // get place from long / lat and set it to vm.searchInput ?

                    var userPos = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    }

                    var payload = {
                        'longitude': userPos.lng,
                        'latitude': userPos.lat,
                        'within': 200
                    }
                    vm.locateActive = false
                    vm.updateUserPos(userPos)
                    vm.updateFromSearch(payload)
                }, function() {
                    vm.handleLocationError(true, App.map.getCenter())
                });
            } else {
                vm.handleLocationError(false, App.map.getCenter())
            }
        },
        searchMe: function(event) {
            var vm = this
            App.showLoading()
            vm.searchInput = vm.place.name
            var lat = vm.place.geometry.location.lat()
            var lng = vm.place.geometry.location.lng()
            var userPos = {
                lat: lat,
                lng: lng
            }
            var payload = {
                'longitude': userPos.lng,
                'latitude': userPos.lat,
                'within': 200
            }
            vm.updateUserPos(userPos)
            vm.updateFromSearch(payload)
        },
        findMarkerInList: function(marker) {
            var idx = marker.label.text.charCodeAt(0) - 65
            var beach = this.beaches[idx]
            this.toggleActiveBeach(beach)
            var list = document.getElementById("search-sidebar-scroll")
            var target = document.getElementById("beach-" + idx)
            list.scrollTop = (target.offsetTop - 220)
            App.map.panTo(marker.getPosition());
            App.map.setZoom(14)
        },
        updateUserPos: function(userPos) {
            this.openSidebar = true
            this.clearUserPos()
            this.userPos = new google.maps.Marker({
                position: userPos,
                icon: new google.maps.MarkerImage('/assets/you-marker.svg',
                    null, null, null, new google.maps.Size(48, 48)),
                labelClass: "marker-label",
            })
            this.userPos.setMap(App.map)
            App.map.setZoom(10)
            App.map.setCenter(userPos)
        },
        updateFromSearch: function(payload) {
            var vm = this
            vm.clearAll()
            var results = App.getNearestSpots(payload)

            for (var i=0; i<results.length; i++) {
                vm.updateSingleLocation(results[i], i)
            }

            google.maps.event.trigger(App.map, "resize")
            App.map.setCenter(this.userPos.getPosition())
            App.hideLoading()
        },
        updateSingleLocation: function(location, idx) {
            var vm = this
            var label = String.fromCharCode(65 + idx)
            var marker = new google.maps.Marker({
                map: App.map,
                icon: {
                    url: '/assets/beach-marker.svg',
                    scaledSize: new google.maps.Size(48, 48),
                    labelOrigin: new google.maps.Point(24, 18)
                },
                label: {
                    color: '#fff',
                    text: label,
                    fontFamily: 'Lato',
                },
                position: {lat: location.lat, lng: location.lon}
            })
            marker.addListener('click', function() {
              vm.findMarkerInList(this)
            })
            vm.markers.push(marker)
            location.active = false
            vm.beaches.push(location)
        },
        clearAll: function() {
            for (var i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
            this.beaches = []
            this.markers = []
        },
        clearUserPos: function() {
            if (this.userPos !== null) {
                this.userPos.setMap(null);
                this.userPos = null
            }
        },
        toggleMap: function() {
            this.mobileMapVisible = !this.mobileMapVisible
        },
        toggleActiveBeach: function(beach) {
            var showDetails;
            if (beach.active === true) {
                beach.active = false
                // reset map
                App.map.setZoom(10)
                if (this.userPos !== null) {
                    App.map.panTo(this.userPos.getPosition())
                }
                var center = App.map.getCenter()
                setTimeout(function() {
                    google.maps.event.trigger(map, 'resize')
                    App.map.setCenter(center)
                }, 50);
                showDetails = false
            } else {
                this.beaches.forEach(function(beach){
                    beach.active = false
                })
                beach.active = true
                // find marker for this beach and zoom to it
                var idx = this.beaches.indexOf(beach)
                var marker = this.markers[idx]
                App.map.panTo(marker.getPosition())
                App.map.setZoom(14)
                showDetails = true
            }
            eventBus.$emit('showDetailsEvent', {
                'showDetails': showDetails, 'beach': beach
            })
        },
        handleLocationError: function(browserHasGeolocation, pos) {
            var vm = this
            var infoWindow = new google.maps.InfoWindow({map: App.map})
            infoWindow.setPosition(pos)
            infoWindow.setContent(browserHasGeolocation ? 'Browser geolocation is disabled' :
                'Your browser doesn\'t support geolocation :(')
            App.hideLoading()
            vm.locateActive = false
        }
    }
}
</script>
